import _ from 'lodash'
export default {
  package: (state, getters) => (id) => {
    return _.find(state.packages, ['id', id])
  },
  cartItemCount: (state) => {
    return state.cart.reduce((total, item) => total + item.quantity, 0)
  },
  cartTotal: (state) => {
    return state.cart.reduce((total, item) => total + (item.price * item.quantity), 0)
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js